function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("title", null, "S\xF6k");
var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");
var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Desktop---Sidor",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Startsida---Bildheader",
  transform: "translate(-1253.000000, -38.000000)",
  fill: "#333333",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Header-new-Copy-2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Header-v1"
}, /*#__PURE__*/React.createElement("g", {
  id: "S\\xF6k",
  transform: "translate(1253.000000, 38.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9,18 C4.03714286,18 0,13.9628571 0,9 C0,4.03714286 4.03714286,0 9,0 C13.9628571,0 18,4.03714286 18,9 C18,13.9628571 13.9628571,18 9,18 Z M9,2.18181818 C5.24045455,2.18181818 2.18181818,5.24045455 2.18181818,9 C2.18181818,12.7595455 5.24045455,15.8181818 9,15.8181818 C12.7595455,15.8181818 15.8181818,12.7595455 15.8181818,9 C15.8181818,5.24045455 12.7595455,2.18181818 9,2.18181818 Z",
  id: "Shape"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.5365983,19.2594726 L14.3612518,14 C13.8978438,14.5816775 13.5964546,14.7907716 13,15.2426987 L18.1257045,20.598435 C18.3455696,20.812853 19.1034792,21.2999167 19.7422499,20.7403862 C20.205504,20.3345992 19.9875164,19.6939694 19.5365983,19.2594726 Z",
  id: "Path"
}))))));
const SvgIconSearch = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "21px",
    viewBox: "0 0 20 21",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};
const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconSearch, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-search.4ae5de32.svg";
export { ForwardRef as ReactComponent };